
// Terms and conditions validation
class CartTermsValidator {
  constructor() {
    this.init();
  }

  init() {
    // Handle cart page checkout button
    const cartCheckoutButton = document.getElementById('checkout');
    if (cartCheckoutButton) {
      cartCheckoutButton.addEventListener('click', this.validateTerms.bind(this));
    }

    if(document.querySelector('.cart-notification-wrapper #cart-terms-checkbox')) {
      const cartCheckoutCB = document.querySelector('.cart-notification-wrapper #cart-terms-checkbox');
      console.log("cartCheckoutButton", cartCheckoutButton);
      cartCheckoutCB.addEventListener('change', function() {
        console.log("cartCheckoutCB", cartCheckoutCB.checked);
        if(cartCheckoutCB.checked == true) {
          cartCheckoutButton.disabled = false;
        } else {
          cartCheckoutButton.disabled = true;
        }
      });
    }
  }

  validateTerms(event) {
    const button = event.target;
    const isTermsRequired = button.getAttribute('data-terms-required') === 'true';
    
    if (!isTermsRequired) return;

    let checkbox;
    if (button.form && button.form.id === 'cart-notification-form') {
      checkbox = document.getElementById('cart-notification-terms-checkbox');
    } else {
      checkbox = document.getElementById('cart-terms-checkbox');
    }

    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      this.showTermsPopup();
      return false;
    }
  }

  showTermsPopup() {
    // Create popup modal
    const modal = document.createElement('div');
    modal.className = 'cart-terms-modal';
    modal.innerHTML = `
      <div class="cart-terms-modal__backdrop">
        <div class="cart-terms-modal__content">
          <div class="cart-terms-modal__header">
            <h2 class="cart-terms-modal__title">${window.cartStrings.termsPopupTitle.replace('{{ shop_name }}', window.Shopify.shop.name || 'Webshop')}</h2>
          </div>
          <div class="cart-terms-modal__body">
            <p>${window.cartStrings.termsNotAccepted}</p>
          </div>
          <div class="cart-terms-modal__footer">
            <button type="button" class="cart-terms-modal__button button">${window.cartStrings.termsPopupButton}</button>
          </div>
        </div>
      </div>
    `;

    // Add styles
    const styles = `
      <style>
        .cart-terms-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 999999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cart-terms-modal__backdrop {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }
        .cart-terms-modal__content {
          background: rgb(var(--color-background));
          border-radius: 0.5rem;
          max-width: 40rem;
          width: 100%;
          position: relative;
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.3);
        }
        .cart-terms-modal__header,
        .cart-terms-modal__body,
        .cart-terms-modal__footer {
          padding: 2rem;
        }
        .cart-terms-modal__header {
          border-bottom: 0.1rem solid rgba(var(--color-foreground), 0.1);
        }
        .cart-terms-modal__title {
          margin: 0;
          color: rgb(var(--color-foreground));
        }
        .cart-terms-modal__body p {
          margin: 0;
          color: rgb(var(--color-foreground));
          line-height: 1.5;
        }
        .cart-terms-modal__footer {
          border-top: 0.1rem solid rgba(var(--color-foreground), 0.1);
          text-align: center;
        }
        .cart-terms-modal__button {
          margin: 0;
        }
      </style>
    `;

    document.head.insertAdjacentHTML('beforeend', styles);
    document.body.appendChild(modal);

    // Handle close
    const closeButton = modal.querySelector('.cart-terms-modal__button');
    const backdrop = modal.querySelector('.cart-terms-modal__backdrop');
    
    const closeModal = () => {
      modal.remove();
    };

    closeButton.addEventListener('click', closeModal);
    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) {
        closeModal();
      }
    });

    // Focus the button for accessibility
    closeButton.focus();
  }
}

// Make CartTermsValidator available globally
window.CartTermsValidator = CartTermsValidator;

// Initialize terms validator when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartTermsValidator();
  });
} else {
  new CartTermsValidator();
}
